import ApiService from "../../../../services/ApiService";

export const fetchUserDocuments = (userId: number, setDocuments: Function, setLoading: Function) => {
  setLoading(true);

  ApiService.get(`users/${userId}/documents`)
    .then((response) => setDocuments(response.data.documents))
    .catch((error) => console.error("An error occurred while fetching user's documents", error))
    .finally(() => setLoading(false));
};

export const openDocument = (type: string, filename: string) => {
  window.open(`${process.env.REACT_APP_FILE_URL}/${type}/${filename}`, "_blank");
};
